import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=22674bf2&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "./contract.vue?vue&type=style&index=0&id=22674bf2&lang=scss"
import style1 from "./contract.vue?vue&type=style&index=1&id=22674bf2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22674bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22674bf2')) {
      api.createRecord('22674bf2', component.options)
    } else {
      api.reload('22674bf2', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=22674bf2&scoped=true", function () {
      api.rerender('22674bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/components/contract.vue"
export default component.exports